/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
// Extends From
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';

// Ember Imports
import { action } from '@ember/object';
import { service } from '@ember/service';

// Internal Imports
import PostStatus from '@linc-technologies/linced-common/enums/post-status';
import Scopes from '@linc-technologies/linced-common/enums/scopes';
import { classNames } from '@ember-decorators/component';

@classNames('post-filter')
export default class PostFilter extends Component {
  // Services
  @service
  permissions;

  PostStatus = PostStatus;
  Scopes = Scopes;

  // Variables
  @tracked isDropdownOpen = false;

  // Params
  startTime = 0;

  endTime = 0;
  autoFilter = '';
  status = '';
  @tracked selectedAuthors = [];
  sortedRemainingAuthors = [];
  @tracked selectedGroups = [];
  sortedRemainingGroups = [];
  setSearchQuery() {}
  addAuthor() {}
  removeAuthor() {}
  setStartTime() {}
  setEndTime() {}
  clear() {}
  filterDay() {}
  filterWeek() {}
  filterSevenDays() {}
  filterPostStatus() {}
  addGroup() {}
  removeGroup() {}

  get filterDropdownOpen() {
    return (
      this.selectedAuthors.length ||
      this.selectedGroups.length ||
      this.isDropdownOpen
    );
  }

  @action
  toggleFilterDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
}
